<template>
  <BonatitanNav>エラー</BonatitanNav>
  <section class="l-section--form --ta-center mt-lg">
    <BonatitanOutputField>予期しないエラーが発生しました。</BonatitanOutputField>
    <p>
      {{ baseMessage }}
    </p>
  </section>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
const baseMessage = '大変申し訳ありませんが、しばらく経ってから再度お試しください。'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    required: true,
  },
})
</script>

<style scoped lang="scss">
.u-text--outputfield {
  color: var(--c-warning);
}

p {
  color: var(--c-text);
}
</style>
